import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { BiDish } from 'react-icons/bi';
import AppContext from '../context/AppContext';
import '../styles/Login.css';
import logo from '../images/login-wallpaper.jpg';

function Login() {
  const history = useHistory();
  const { email,
    setEmail,
    password,
    setPassword,
    isDisabledButton,
    setIsDisabledButton } = useContext(AppContext);

  const handleChange = ({ target: { value, name } }) => {
    if (name === 'email') {
      setEmail(value);
    } if (name === 'password') {
      setPassword(value);
    }

    const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/i;
    const verifyEmail = emailRegex.test(email);
    const number = 5;
    const verifyPassword = password.length > number;
    setIsDisabledButton(!(verifyEmail && verifyPassword));
  };

  const handleClick = (event) => {
    event.preventDefault();
    localStorage.setItem('user', JSON.stringify({ email }));
    history.push('/meals');
  };

  return (
    <div
      className="form-login-container"
      style={ {
        backgroundImage: `url(${logo})`,
        backgroundSize: 'cover',
      } }
    >
      <form onSubmit={ handleClick } className="form-login">
        <div className="logo">
          <BiDish />
          <p>
            <strong>
              JSON
            </strong>
            .foodify()
          </p>
        </div>
        <h2 className="title">Login</h2>
        <input
          data-testid="email-input"
          type="email"
          name="email"
          onChange={ handleChange }
          value={ email }
          placeholder="Email"
        />
        <input
          data-testid="password-input"
          type="password"
          name="password"
          onChange={ handleChange }
          value={ password }
          placeholder="Password"
        />
        <button
          data-testid="login-submit-btn"
          type="submit"
          disabled={ isDisabledButton }
        >
          Enter
        </button>
      </form>
    </div>
  );
}

export default Login;
